import { render, staticRenderFns } from "./MailDetail.vue?vue&type=template&id=8d619ca8&scoped=true&"
import script from "./MailDetail.vue?vue&type=script&lang=js&"
export * from "./MailDetail.vue?vue&type=script&lang=js&"
import style0 from "./MailDetail.vue?vue&type=style&index=0&id=8d619ca8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d619ca8",
  null
  
)

export default component.exports